import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useCustomerEnrichApiConfigUpdate } from 'features/customers/hooks/useCustomerEnrichApiConfigUpdate'
import { ENRICH_API_LIMIT_LABELS } from 'features/customers/utils/features'

import { FormTextField } from 'components/input'
import { DescriptionListTable } from 'components/table'
import { withForm } from 'decorators/withForm'
import { parseDomainAllowlistInput } from 'validators/domain-allowlist'
import { modifyEnrichApiLimitsValidator } from 'validators/enrich-api'

const config = [
  {
    title: ENRICH_API_LIMIT_LABELS.enrichApiRequestsLimit,
    render: () => <FormTextField name="quota" type="number" />,
  },
  {
    title: 'Domain Allowlist',
    render: () => (
      <FormTextField
        helperText="Comma-separated list of allowed domains, e.g. example.com, app.example.com"
        name="publicApiKeyDomainAllowlist"
        placeholder="example.com, app.example.com"
      />
    ),
  },
]

type EnrichApiLimitsModalProps = {
  handleSubmit: (...args: any[]) => any
  onClose: (...args: any[]) => any
}

const EnrichApiLimitsModal = ({ handleSubmit, onClose }: EnrichApiLimitsModalProps) => {
  const { updateEnrichApiConfig } = useCustomerEnrichApiConfigUpdate()

  const onSubmit = async values => {
    await updateEnrichApiConfig({
      quota: Number.parseInt(values.quota, 10),
      publicApiKeyDomainAllowlist: parseDomainAllowlistInput(values.publicApiKeyDomainAllowlist),
    })
    onClose()
  }

  return (
    <Dialog onClose={onClose} open>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Manage Enrich API limits</DialogTitle>
        <DialogContent style={{ width: 500 }}>
          <DescriptionListTable config={config} titleCellStyle={{ width: 200 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="primary" type="submit">
            Update
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default withForm({ form: 'enrichApiLimitsModify', validate: modifyEnrichApiLimitsValidator })(
  EnrichApiLimitsModal,
)
